import { PaginationTable } from '../../../common/components';

const InventoryArticlesPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <PaginationTable
    totalPages={totalPages}
    totalCount={totalCount}
    page={page}
    rowsPerPage={rowsPerPage}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);

export default InventoryArticlesPagination;
